import styled, { css } from 'styled-components';
import { TextLabel } from '../TextLabel';
import { MessageType } from './AppMessageMessage.model';

const StyledContainer = styled.div<{ $type: MessageType }>`
	display: flex;
	gap: 10px;
	flex-direction: ${(props) =>
		props.$type === MessageType.Incoming ? 'row' : 'row-reverse'};
`;

const StyledImage = styled.img<{ $online?: boolean }>`
	width: 40px;
	height: 40px;
	border-radius: 40px;

	${(props) =>
		props.$online
			? css`
					padding: 2px;
					border: 2px solid #77de38;
			  `
			: css`
					filter: grayscale(1);
			  `}
`;

const StyledNameContainer = styled.div<{
	$type: MessageType;
	$online: boolean;
}>`
	display: flex;
	gap: 10px;
	flex-direction: ${(props) =>
		props.$type === MessageType.Incoming ? 'row' : 'row-reverse'};

	.name {
		font-weight: 500;
		font-size: 14px;
		color: ${(props) =>
			props.$type === MessageType.Outgoing
				? '#FFFFFF'
				: props.$online
				? '#77DE38'
				: 'rgba(255, 255, 255, 0.5)'};
	}

	.time {
		font-weight: 400;
		font-size: 10px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledMessageContainer = styled.div<{ $type: MessageType }>`
	display: flex;
	flex-direction: column;
	align-items: ${(props) =>
		props.$type === MessageType.Outgoing ? 'flex-end' : 'flex-start'};
	gap: 9px;
`;

const StyledTextContainer = styled.div<{ $type: MessageType }>`
	padding: 12px 15px;
	max-width: 480px;
	background-color: ${(props) =>
		props.$type === MessageType.Outgoing
			? '#2D70DA'
			: 'rgba(255,255,255,0.05)'};

	border-radius: ${(props) =>
		props.$type === MessageType.Outgoing
			? '10px 0 10px 10px'
			: '0 10px 10px 10px'};

	${TextLabel} {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
	}
`;

export {
	StyledContainer,
	StyledImage,
	StyledNameContainer,
	StyledMessageContainer,
	StyledTextContainer,
};
